import A from './components/A';
import B from './components/B';

export default function DeltaProUltraTeaser() {
    return (
        <>
            <A />
            <B />
        </>
    );
}
